"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const shared_1 = require("../../shared");
const SignInLink = ({ href, nofocus }) => {
    const { messages } = (0, shared_1.useMessages)();
    return (react_1.default.createElement("a", { role: "menuitem", tabIndex: nofocus ? -1 : 0, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, href: href, title: messages.sign_in },
        react_1.default.createElement("i", { className: "eg-header-icon-user" }),
        react_1.default.createElement("span", { className: "user-label" }, messages.sign_in)));
};
exports.SignInLink = SignInLink;
//# sourceMappingURL=SignInLink.js.map